export const ITEM_SPECIFICATIONS_GET_REQUEST = "@itemspecifications.get.request";
export const ITEM_SPECIFICATIONS_GET_SUCCESS = "@itemspecifications.get.success";
export const ITEM_SPECIFICATIONS_GET_FAIL = "@itemspecifications.get.failure";

export const ITEM_SPECIFICATION_LOAD_REQUEST = "@itemspecification.load.request";
export const ITEM_SPECIFICATION_LOAD_SUCCESS = "@itemspecification.load.success";
export const ITEM_SPECIFICATION_LOAD_FAIL = "@itemspecification.load.failure";

export const ITEM_SPECIFICATION_CREATE_REQUEST = "@itemspecification.create.request";
export const ITEM_SPECIFICATION_CREATE_SUCCESS = "@itemspecification.create.success";
export const ITEM_SPECIFICATION_CREATE_FAIL = "@itemspecification.create.failure";
export const ITEM_SPECIFICATION_CREATE_DONE = "@itemspecification.create.done";

export const ITEM_SPECIFICATION_UPDATE_REQUEST = "@itemspecification.update.request";
export const ITEM_SPECIFICATION_UPDATE_SUCCESS = "@itemspecification.update.success";
export const ITEM_SPECIFICATION_UPDATE_FAIL = "@itemspecification.update.failure";
export const ITEM_SPECIFICATION_UPDATE_DONE = "@itemspecification.update.done";

export const ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED = "@itemspecification.item_specification_is_created_or_updated";
export const ITEM_SPECIFICATION_IS_CREATED_OR_UPDATED_RESET =
    "@itemspecification.item_specification_is_created_or_updated.reset";
